"use client";
import { validateRequest } from "@/libs/builder/builderApi";
import { useEffect } from "react";

declare global {
  interface Window {
    onCheqResponse?: (argument1: unknown, RequestId: string) => void;
    requestId: string | null;
  }
}

export const CheqRequestValidator = () => {
  useEffect(() => {
    window.onCheqResponse = (_, requestId) => {
      window.requestId = requestId;
      validateRequest(window.location.href, requestId);
    };

    return () => {
      window.onCheqResponse = undefined;
      window.requestId = null;
    };
  }, []);

  return null;
};
